import {
  GroupLabelContext
} from "./F5VAC7MB.js";
import {
  createComponent,
  createElement,
  createHook
} from "./NQJBHION.js";
import {
  useWrapElement
} from "./J7Q2EO23.js";
import {
  __spreadValues
} from "./PNRLI7OV.js";

// src/group/group.tsx
import { useState } from "react";
import { jsx } from "react/jsx-runtime";
var useGroup = createHook((props) => {
  const [labelId, setLabelId] = useState();
  props = useWrapElement(
    props,
    (element) => /* @__PURE__ */ jsx(GroupLabelContext.Provider, { value: setLabelId, children: element }),
    []
  );
  props = __spreadValues({
    role: "group",
    "aria-labelledby": labelId
  }, props);
  return props;
});
var Group = createComponent((props) => {
  const htmlProps = useGroup(props);
  return createElement("div", htmlProps);
});
if (process.env.NODE_ENV !== "production") {
  Group.displayName = "Group";
}

export {
  useGroup,
  Group
};
